// src/components/Hero.js
import React from 'react';
import '../styles/talent.scss';
import { Link } from 'react-router-dom';

function Talent() {
  const immagini = [
    { image: '/images/Talent/Megan_Talent.jpg', title: ["MEGAN RIA"], className: "" },
    { image: '/images/Talent/Maddalena_Talent.jpg', title: ["MADDALENA SVEVI"], className: ""},
    { image: '/images/Talent/Gioele_Arreghini.jpg', title: ["GIOELE ARREGHINI"], className: "" },
    { image: '/images/Talent/Elena_Azinah.jpg', title: ["ELENA HAZINAH"], className: "" },
    { image: '/images/Talent/FRANCESCA_AMARA.jpg', title: ["FRANCESCA AMARA"], className: ""},
    { image: '/images/Talent/Giulia_XIE.jpg', title: ["GIULIA XIE"], className: "adjust-center2" },
    { image: '/images/Talent/VALENTINA_VERNIA.jpg', title: ["VALENTINA VERNIA"], className: ""},
    { image: '/images/Talent/GLORIA_SCHITO.jpg', title: ["GLORIA SCHITO"], className: "" },
    { image: '/images/Talent/NICHOLAS_BORGOGNI.jpg', title: ["NICHOLAS BORGOGNI"], className: "adjust-center" },
    { image: '/images/Talent/GIADA_HASSANN.jpg', title: ["GIADA HASSANN"], className: "adjust-center" },
    { image: '/images/Talent/GiuliaPelagatti.JPG', title: ["GIULIA PELAGATTI"], className: "adjust-center" },
    { image: '/images/Talent/camilla.jpeg', title: ["CAMILLA CLEMENTE"], className: "" },
    { image: '/images/Talent/Samuele.PNG', title: ["SAMUELE MARAGLIANO"], className: "" },
    { image: '/images/Talent/FedericaScagnetti.jpg', title: ["FEDERICA SCAGNETTI"], className: "" },
    { image: '/images/Talent/GiuseppeMenozzi.jpg', title: ["GIUSEPPE MENOZZI"], className: "" },
    
  ];

  return (
    <section className="talent">
      <div className="image-grid">
        {immagini.map((img, index) => (
          <div key={index} className={`image-grid__item ${img.className}`}>
            <Link to={img.link}>
              <img src={img.image} alt={img.title.join(' ')} />
              <h3 className="image-grid__title">
                {img.title.map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < img.title.length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Talent;